<section *ngIf="auditType() === 'profile'">

      <div class="card">
        <div class="card-body">
          <h3 class="card-header">
            TOP10 influencers
            <a data-tooltip="Top 10 influencers who are fans or had interactions in the last 30 days">
              <img class="icon-info" src="./assets/images/icons/info.png" />
            </a>
          </h3>

          <div class="btn-group text-center mt-4 mb-5">
            <button class="btn" [ngClass]="type === 1 ? 'btn-blue' : 'btn-default'" (click)="getProfile(1)">
              TOP10 who follows
            </button>
            <button class="btn" [ngClass]="type === 2 ? 'btn-blue' : 'btn-default'" (click)="getProfile(2)">
              TOP10 who liked
            </button>
            <button class="btn" [ngClass]="type === 3 ? 'btn-blue' : 'btn-default'" (click)="getProfile(3)">
              TOP10 who commented
            </button>
          </div>
          <div class="spinner" *ngIf="!(profileState | async).loader['audit']['userRank']"></div>
          <div
            class="col-12 p-0"
            [ngClass]="!(profileState | async).loader['audit']['userRank'] ? 'background-loader' : ''"
          >
            <div class="table-responsive">
              <table
                class="table table-bordered"
                *ngIf="((profileState | async).audit !== null && (profileState | async).audit.status === 2)"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Profile</th>
                    <th>No. of followers</th>
                    <th>No. of likes</th>
                    <th>No. of comments</th>
                    <th>Influencer's report</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let user of (profileState | async).userRank; let i = index;">
                    <td>{{i + 1}}.</td>
                    <td>
                      <img [src]="user.user.profile_pic_url" default="./assets/images/user-avatar.png" class="avatar vertical-middle mr-2" width="30">
                      <a class="link-underlined" href="{{'https://www.instagram.com/' + user.user.username}}" target="_blank" >
                        &#64;{{user.user.username}}
                      </a>
                    </td>
                    <td>{{user.user.followed_by | shortcutNumbers}}</td>
                    <td>{{user.counter.like_count}}</td>
                    <td>{{user.counter.comment_count}}</td>
                    <td>
                      <button
                        class="btn btn-light btn-sm"
                        (click)="addProfileAudit(user.user.username)"
                        [disabled]="!(profileState | async).loader['auditAdd']['add']"
                      >
                        <span *ngIf="(profileState | async).loader['auditAdd']['add']">Generate audit</span>
                        <span *ngIf="!(profileState | async).loader['auditAdd']['add']">Loading...</span>
                      </button> </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="text-center mb-5" *ngIf="((profileState | async).audit !== null && (profileState | async).audit.status === 1)">
              <p>Audit in progess. Please wait to see the results</p>
            </div>
            <div class="text-center mb-5" *ngIf="((profileState | async).audit !== null && (profileState | async).audit.status === 0)">
              <a class="btn btn-blue btn-lg btn-animated mt-3" routerLink="/payment/add">
                <img width="16" class="mr-1" src="assets/images/icons/star.png"/>
                Unlock full report
              </a>
            </div>
          </div>


        </div>
      </div>

</section>
